/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Plan_DescInputs */

const en_mk_preview_plan_desc = /** @type {(inputs: Mk_Preview_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer questions, add references, and review your requirements before building.`)
};

const id_mk_preview_plan_desc = /** @type {(inputs: Mk_Preview_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawab pertanyaan, tambahkan referensi, lalu tinjau dokumen kebutuhan sebelum mulai membangun.`)
};

/**
* | output |
* | --- |
* | "Answer questions, add references, and review your requirements before building." |
*
* @param {Mk_Preview_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_plan_desc = /** @type {((inputs?: Mk_Preview_Plan_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Plan_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_plan_desc(inputs)
	return en_mk_preview_plan_desc(inputs)
});